import styled from "styled-components";

export const NavWrapper = styled.div`
	min-height: 10vh;
	padding: 1rem 0;
`;

export const Logo = styled.h1`
	font-size: 2rem;
`;
